/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Google Maps embed (map-landing section): the iframe loads ~460 KiB of JS, so it is only injected when the map
 * gets close to the viewport, or when its placeholder is clicked.
 */
(function () {
  function loadMap(container) {
    if (container.hasAttribute('data-map-loaded')) {
      return;
    }

    var iframe = document.createElement('iframe'),
        placeholder = container.querySelector('[data-action="load-map"]');

    container.setAttribute('data-map-loaded', '');
    iframe.src = container.getAttribute('data-map-embed');
    iframe.title = container.getAttribute('data-map-title');
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.style.border = '0';
    iframe.setAttribute('allowfullscreen', '');

    if (placeholder) {
      placeholder.parentNode.removeChild(placeholder);
    }

    container.appendChild(iframe);
  }

  function initMaps(root) {
    var containers = Array.prototype.slice.call(root.querySelectorAll('[data-map-embed]:not([data-map-loaded])'));

    if (containers.length === 0) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      containers.forEach(loadMap);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          loadMap(entry.target);
        }
      });
    }, {
      rootMargin: '200px 0px'
    });

    containers.forEach(function (container) {
      observer.observe(container);
    });
  }

  document.addEventListener('click', function (event) {
    var placeholder = event.target.closest('[data-action="load-map"]');

    if (placeholder) {
      loadMap(placeholder.closest('[data-map-embed]'));
    }
  });

  // Theme editor: sections are re-rendered without a page reload
  document.addEventListener('shopify:section:load', function (event) {
    initMaps(event.target);
  });

  // With the critical CSS, wait for theme.css: on the unstyled page the map could be (wrongly) close to the viewport
  if (window.themeStylesheets) {
    window.themeStylesheets.onLoad(function() {
      initMaps(document);
    });
  } else {
    initMaps(document);
  }
})();



